module.exports = __webpack_public_path__ + "img/bao_damper.15c4d8c3.jpg";